import React from "react";
import PropTypes from "prop-types";

import Speaker from "./index";

import * as styles from "./style.module.scss";

const SpeakerSmallList = ({ speakers, title, cardColor }) => {
  return (
    <>
      <h2
        style={{
          paddingBottom: "5px",
          paddingLeft: "30px",
          paddingRight: "15px",
          fontFamily: "Raleway, Arial, sans-serif",
          textAlign: "center !important",
          display: "block",
        }}
      >
        {title}
      </h2>
      <div className={styles.speakerSmallListWrapper}>
        {speakers.map((speaker, i) => (
          <Speaker key={String(i)} {...speaker} cardColor={cardColor} />
        ))}
      </div>
    </>
  );
};

SpeakerSmallList.propTypes = {
  speakers: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  cardColor: PropTypes.string.isRequired,
};

export default SpeakerSmallList;
